import React, { createContext, useContext, useState, useEffect } from 'react';
// translations dosyasının yolunun doğru olduğundan emin ol
import { dictionary, languages, getTranslation } from '../translations/translations';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  // 1. Varsayılan Dil Ayarı
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('burofuchs_language') || 'de';
  });

  // 2. Dil Değiştirme Fonksiyonu (Mantıksal İşlemler)
  const changeLanguage = (langCode) => {
    setLanguageState(langCode);
    localStorage.setItem('burofuchs_language', langCode);
    
    // RTL (Arapça) Desteği Kontrolü
    if (langCode === 'sa') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  };

  // 3. Çeviri Fonksiyonu
  const t = (key) => {
    return getTranslation(language, key);
  };

  return (
    <LanguageContext.Provider value={{ 
        language, 
        // 🔥 HATA ÇÖZÜMÜ BURADA:
        // Hem 'changeLanguage' hem de 'setLanguage' aynı işlevi görecek şekilde ayarlandı.
        changeLanguage, 
        setLanguage: changeLanguage, // Dashboard eski isimlendirmeyi kullanıyorsa hata vermesin
        t, 
        languages 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};